import { type AuditMessage, auditMessage } from './text';
import type { AuditLogEntry, AuditLogFilters, AuditOutcome } from './types';

export interface AuditOutcomeDescription {
    outcome: AuditOutcome;
    /** "Success", "Denied" or "Failed", for a cell that makes the code its own click. */
    word: AuditMessage;
    /** The status code recorded on a denied or failed entry. */
    code: string | null;
    /** "Success", or "Denied 401" / "Failed 502" when a status code was recorded. */
    label: AuditMessage;
    filter: AuditLogFilters;
    /** Null on success rows and on failures the backend recorded without a code. */
    statusFilter: AuditLogFilters | null;
}

export function describeAuditOutcome(entry: AuditLogEntry): AuditOutcomeDescription {
    const outcome = auditMessage(`auditLog.outcome.${entry.outcome}`);
    const code = entry.outcome === 'success' ? null : entry.statusCode;
    return {
        outcome: entry.outcome,
        word: outcome,
        code: code === null ? null : String(code),
        label:
            code === null
                ? outcome
                : auditMessage('auditLog.outcome.withStatus', { outcome, code: String(code) }),
        filter: { outcome: [entry.outcome] },
        statusFilter: code === null ? null : { statusCode: code },
    };
}
